// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"312702e1","831":"a86d3c12","928":"073909c3"}[chunkId] + ".chunk.js";
};